export const meta: BlockMeta = {
  title: "Button",
  description: "A styled button",
  category: "layouts",
  icon: "book-alt",
  keywords: ["post"],
  conditions: {
    postTypes: ["page", "post", "article", "hall-of-fame", "resource"],
  },
  tags: ["root"],
}

import { Button } from "@components/controls/Button"
import { defineBlock, EditableText } from "eddev/blocks"

export default defineBlock("content/button", (props) => {
  return (
    <Button variant={props.variant as any} size={props.size as any} href={!env.admin ? props.link?.url : undefined} target={!env.admin ? props.link?.target : undefined}>
      {props.link?.title || "Button"}
    </Button>
  )
})
